import moment from 'moment';
import i18n from '../i18n';

const ONE_MONTH = 30 * 24 * 3600 * 1000;
const FORTY_FIVE_MIN = 0.75 * 3600 * 1000;

const formatDate = (date?: string | null): string | undefined => {
  if (date) {
    if (moment().diff(moment(date)) > ONE_MONTH) {
      // more than about a month ago
      return moment(date).calendar(undefined, {
        sameElse: `MMM D, YYYY`,
      });
    }
    if (moment().diff(moment(date)) > FORTY_FIVE_MIN) {
      return moment(date).calendar(undefined, {
        sameDay: `[${i18n.t('common:today')} at] h[:]mm A`,
        nextDay: `[${i18n.t('common:tomorrow')}]`,
        nextWeek: `dddd`,
        lastDay: `[${i18n.t('common:yesterday')} at] h[:]mm A`,
        lastWeek: `ddd [at] h[:]mm A`,
        sameElse: `MMM D [at] h[:]mm A`,
      });
    }
    return moment(date).fromNow();
  } else {
    return;
  }
};

export { formatDate };
